import {
  listen,
  partnerIdMessage,
  isPartnerIdRequestMessage,
  sendLocal,
  isExitPartnerMessage,
} from "@sinch/bus";
import { useEffect } from "react";
import { patchRefreshToken } from "../auth";
import {
  isStringOrNull,
  getLocalStorage,
  removeLocalStorage,
  PARTNER_ACCOUNT_ID_STORAGE_KEY,
} from "../helpers/localStorage";

const getPartnerId = () =>
  getLocalStorage(PARTNER_ACCOUNT_ID_STORAGE_KEY, isStringOrNull, undefined);

const exitPartnerAccount = async () => {
  const partnerId = getLocalStorage(
    PARTNER_ACCOUNT_ID_STORAGE_KEY,
    isStringOrNull,
    undefined
  );
  if (partnerId) {
    await patchRefreshToken(
      {
        accountId: partnerId,
        onPatchSuccess: () =>
          removeLocalStorage(PARTNER_ACCOUNT_ID_STORAGE_KEY),
        redirectUrl: "/customer-accounts",
      },
      {
        reason: "switch back",
        roles: ["admin", "user"],
      }
    );
  }
};
// Currently is made for Message media partner functionality
export const usePartnerIdHandler = () => {
  useEffect(() => {
    const unsub = listen((message) => {
      if (isPartnerIdRequestMessage(message)) {
        const partnerId = getPartnerId();
        partnerId && sendLocal(partnerIdMessage(partnerId));
      } else if (isExitPartnerMessage(message)) {
        exitPartnerAccount();
      }
    });

    return unsub;
  }, []);
};
